import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { ExecutionErrorService } from 'tnx-admin-service/workflowcore/executionerror/services';
@Component({
    selector: 'executionerror',
    templateUrl: './executionerror.component.html',
    styleUrls: ['./executionerror.component.scss'],
    providers: [ComponentContextService],
})
export class ExecutionErrorComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _executionErrorService: ExecutionErrorService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._executionErrorService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'errorTime', dataType: 'date', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'executionPointerId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'message', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'workflowId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'persistenceId' }),
            new ColumnSchemaBase({ field: 'errorTime' }),
            new ColumnSchemaBase({ field: 'executionPointerId' }),
            new ColumnSchemaBase({ field: 'message' }),
            new ColumnSchemaBase({ field: 'workflowId' }),
            new ColumnSchemaBase({ field: 'currentStateCode' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

